"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const emotion_1 = require("emotion");
const default_1 = __importDefault(require("../../themes/default"));
const { colors, padding, borderRadius, fontSize } = default_1.default;
exports.default = emotion_1.css `
  text-align: center;
  cursor: pointer;
  border: none;
  color: ${colors.white};
  background-color: ${colors.primary.default};
  padding: ${padding[3]} ${padding[6]};
  border-radius: ${borderRadius.xl};
  font-size: ${fontSize.sm};
  font-weight: 600;

  &:hover {
    background-color: ${colors.primary.dark};
  }

  &:active {
    background-color: ${colors.primary.darker};
  }

  &:focus {
    outline: none;
  }
`;
//# sourceMappingURL=style.js.map